// function for setting cell color based on percentage //
import React from "react"


const AsFloat = ({ val, percision }) => {

    var textColor = '#000000'
    if (isNaN(parseInt(val))) {
        textColor = '#b8b8b8'
    }

    return (
        <div style={{
            display : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: textColor
        }}>
            {isNaN(parseFloat(val)) ? '--' : parseFloat(val).toFixed(percision)}
        </div>
    )
    
}

export default AsFloat